import { useQueryClient } from '@tanstack/react-query'
import { signOut, getAuth } from 'firebase/auth'
import { batch, useDispatch } from 'react-redux'
import { setCentreDefault } from '../redux/eccSlice'
import { resetSchoolBookings } from '../redux/schoolBookingsSlice'
import { setSchoolDefault } from '../redux/schoolSlice'
import { setUserRegDefault } from '../redux/userRegistrationSlice'
import { setUserLogout } from '../redux/userSlice'
import { resetPreRegistration } from '../redux/preOnboardingSlice'
import { setOrgDefault } from '../redux/orgSlice'
import { logger } from '../helpers/logger'
import { setTeacherDefault } from '../redux/teacherSlice'

const useSignOutUser = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    const signOutUser = async (
        successCallback?: () => void,
        errorCallback?: () => void
    ) => {
        try {
            await signOut(getAuth())
            successCallback && successCallback()
            sessionStorage.removeItem('spark-auth-token')

            batch(() => {
                dispatch(setOrgDefault())
                dispatch(setTeacherDefault())
                dispatch(setUserLogout())
                dispatch(resetPreRegistration())
                dispatch(setUserRegDefault())
                dispatch(setSchoolDefault())
                dispatch(setCentreDefault())
                dispatch(resetSchoolBookings())
            })

            queryClient.clear()
        } catch (e) {
            logger.error(e)
            errorCallback && errorCallback()
        }
    }

    return [signOutUser]
}

export default useSignOutUser
